import { render, staticRenderFns } from "./ArrearsTransactionNew.vue?vue&type=template&id=d07c992c"
import script from "./ArrearsTransactionNew.vue?vue&type=script&lang=js"
export * from "./ArrearsTransactionNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports